<template>
	<router-link
		tag="a"
		:to="`/lista-productos/${item.category ? item.category.slug : ''}/${item.slug}-detail`"
		class="item"
		:class="{ 'item-horizontal': display == 'horizontal' }"
	>
		<div class="image-wrapper">
			<div class="image" :style="'background-image:url(' + item.image.url + ')'"></div>
			<div class="image-overlay"></div>
		</div>

		<div class="data">
			<h2 class="title">{{ item.name }}</h2>
			<div class="data-items">

				<div class="data-item" v-if="item.dimensions">
					<svg
						xmlns="http://www.w3.org/2000/svg"
						class="icon icon-tabler icon-tabler-dimensions"
						width="24"
						height="24"
						viewBox="0 0 24 24"
						stroke-width="2"
						stroke="currentColor"
						fill="none"
						stroke-linecap="round"
						stroke-linejoin="round"
					>
						<path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
						<path d="M3 5h11"></path>
						<path d="M12 7l2 -2l-2 -2"></path>
						<path d="M5 3l-2 2l2 2"></path>
						<path d="M19 10v11"></path>
						<path d="M17 19l2 2l2 -2"></path>
						<path d="M21 12l-2 -2l-2 2"></path>
						<rect x="3" y="10" width="11" height="11" rx="2"></rect>
					</svg>
					{{ item.dimensions }}
				</div>
				<div class="data-item" v-if="item.capacity">
					<svg
						xmlns="http://www.w3.org/2000/svg"
						class="icon icon-tabler icon-tabler-users"
						width="24"
						height="24"
						viewBox="0 0 24 24"
						stroke-width="2"
						stroke="currentColor"
						fill="none"
						stroke-linecap="round"
						stroke-linejoin="round"
					>
						<path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
						<circle cx="9" cy="7" r="4"></circle>
						<path d="M3 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2"></path>
						<path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
						<path d="M21 21v-2a4 4 0 0 0 -3 -3.85"></path>
					</svg>
					{{ item.capacity }}
				</div>
				<div class="data-item" v-if="item.waterTank">
					<svg
						xmlns="http://www.w3.org/2000/svg"
						class="icon icon-tabler icon-tabler-droplet"
						width="24"
						height="24"
						viewBox="0 0 24 24"
						stroke-width="2"
						stroke="currentColor"
						fill="none"
						stroke-linecap="round"
						stroke-linejoin="round"
					>
						<path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
						<path d="M6.8 11a6 6 0 1 0 10.396 0l-5.197 -8l-5.2 8z"></path>
					</svg>
					{{ item.waterTank }}
				</div>
			</div>
			<div class="price mt-4" v-if="item.salable">
				<span class="currency mr-1">U$S</span>
				<span class="amount">{{ item.price }}</span>
				<small class="ml-1">IVA INC</small>
			</div>
			<div class="mb-2" v-if="item.featured" v-html="item.featuredDetail"></div>
			<button class="btn btn-primary btn-detail">
				Ver detalles
				<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
					<path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
					<path d="M5 12l14 0"></path>
					<path d="M13 18l6 -6"></path>
					<path d="M13 6l6 6"></path>
				</svg>
			</button>
		</div>
	</router-link>
</template>
<script>
export default {
	props: ["item", "display"]
}
</script>
<style scoped>
.item {
	display: flex;
	flex-direction: column;
	position: relative;
	margin: 0;
	padding: 0;
	text-align: center;
	color: #333;
	transition: transform 0.3s ease, box-shadow 0.3s ease;
	background-color: #fff;
	border-radius: 12px;
	overflow: hidden;
	box-shadow: 0 2px 16px rgba(0, 0, 0, 0.08);
	height: 100%;
}
.item:hover {
	transform: translateY(-4px);
	box-shadow: 0 8px 28px rgba(0, 0, 0, 0.13);
}
.item:hover .image {
	transform: scale(1.04);
}

.image-wrapper {
	position: relative;
	overflow: hidden;
}

.item .title {
	font-weight: 700;
	font-size: 1.05rem;
	line-height: 1.3;
	min-height: 44px;
	margin-bottom: 10px;
	color: #1a1a2e;
}
.item .image {
	width: 100%;
	background-size: cover;
	background-position: center center;
	background-repeat: no-repeat;
	padding-bottom: 65%;
	transition: transform 0.4s ease;
}
.image-overlay {
	display: none;
}
.item .data {
	position: relative;
	flex-grow: 1;
	padding: 20px 20px 24px;
	text-align: left;
	display: flex;
	flex-direction: column;
}
.item .data .data-items {
	flex-grow: 1;
	margin-bottom: 6px;
}
.item .data .data-item {
	display: flex;
	padding: 4px 0;
	align-items: center;
	font-size: 13px;
	color: #555;
}
.item .data .data-item svg {
	width: 18px;
	margin-right: 8px;
	color: #4a90d9;
	flex-shrink: 0;
}

.btn-detail {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	gap: 8px;
	padding: 10px 20px;
	border-radius: 8px;
	font-weight: 600;
	font-size: 13px;
	transition: all 0.25s ease;
	margin-top: auto;
}
.btn-detail:hover {
	gap: 12px;
}
.btn-detail svg {
	transition: transform 0.25s ease;
}
.btn-detail:hover svg {
	transform: translateX(3px);
}

.item .price {
	font-size: 15px;
	line-height: 20px;
	margin-bottom: 10px;
}
.item .price .currency {
	font-size: 14px;
	font-weight: 500;
	color: #666;
}
.item .price .amount {
	font-size: 18px;
	font-weight: 700;
	color: #1a1a2e;
}

.badge-primary {
	width: 90px;
	background-color: var(--primary-color);
	border-radius: 20px;
	font-size: 10px;
	font-weight: 500;
	padding: 6px;
	position: absolute;
	top: -20px;
	left: calc(50% - 45px);
}

.item.item-horizontal {
	flex-direction: row;
	align-items: center;
}
.item.item-horizontal .image {
	padding-bottom: 30%;
}
.item.item-horizontal .data {
	text-align: left;
}
.item.item-horizontal .data .btn {
	margin: inherit;
}
</style>
